<template>
	<component :is="layout" :class="layoutClass" :modalOptions="modalOptions">
		<slot v-if="layout === 'Loading'"/>
		<router-view v-else :key="routerViewKey"/>
	</component>
</template>
<script>
import Vue from "vue";
import {mapState} from "vuex";
import Error from "../../layouts/Error";
import Auth from "./layouts/Auth";
import Loading from "./layouts/Loading";
import Portal from "./layouts/Portal";

export default {
	components: {
		Auth,
		Error,
		Loading,
		Portal,
	},

	data() {
		return {
			routerViewKey: 0,
			modalOptions: {},
		};
	},

	computed: {
		...mapState("errorsStore", {
			error: (state) => state.error,
		}),
		...mapState("errorsStore", [
			"error",
		]),
		layout() {
			if (this.error) {
				return "Error";
			}

			if (this.$route.meta.layout) {
				return this.$route.meta.layout;
			}

			return !this.$authed() ? "Loading" : defaultLayout;
		},
		layoutClass() {
			return "app--moving-buddies--" + this.layout.toLowerCase();
		},
	},

	methods: {
		refresh() {
			this.routerViewKey += 1;
		},
		setModalOptions(options) {
			this.modalOptions = options;
		},
		setModalProp(prop, value) {
			if (!this.modalOptions) {
				return;
			}
			Vue.set(this.modalOptions.props, prop, value);
		},
	},
};
</script>
